module.exports = __webpack_public_path__ + "static/media/mb.68f11ba8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/pages/june-5/races/images/mb.webp
// module id = 673
// module chunks = 40 50